import { useEffect } from 'react';
import { GENERAL_COMMUNICATON_TOPICS } from '@branchjs/communicator';
import { Pendo } from './Pendo';
export function usePendo(options) {
    const { communicator } = options;
    const { CONTEXT, GET_PENDO_USER, COMMUNICATE_PENDO_USER } = GENERAL_COMMUNICATON_TOPICS;
    useEffect(() => {
        const pendoService = new Pendo();
        const pendoKeySubscription = communicator.on(CONTEXT, (event) => {
            const { data } = event;
            if (data === null || data === void 0 ? void 0 : data.pendo) {
                pendoService.initialize(data === null || data === void 0 ? void 0 : data.pendo);
                communicator.send(GET_PENDO_USER, true);
            }
        });
        const pendoUserSubscription = communicator.on(COMMUNICATE_PENDO_USER, (event) => {
            const { data } = event;
            const interval = setInterval(() => {
                if (pendoService.addUser(data)) {
                    clearInterval(interval);
                }
            }, 250);
        });
        return () => {
            pendoKeySubscription.unsubscribe();
            pendoUserSubscription.unsubscribe();
        };
    }, []);
}
//# sourceMappingURL=usePendo.js.map